/**
 * TanStack Query hooks for `igaming-scheduled-on-demand-payout`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingScheduledOnDemandPayoutQueryKeys,
	type CreateIgamingScheduledOnDemandPayoutBody,
	type ListIgamingScheduledOnDemandPayoutResponse,
	type IgamingScheduledOnDemandPayoutRow,
} from "./api";

export function useIgamingScheduledOnDemandPayoutList(): UseQueryResult<ListIgamingScheduledOnDemandPayoutResponse, Error> {
	return useQuery({
		queryKey: igamingScheduledOnDemandPayoutQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingScheduledOnDemandPayoutCreate(): UseMutationResult<IgamingScheduledOnDemandPayoutRow, Error, CreateIgamingScheduledOnDemandPayoutBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingScheduledOnDemandPayoutQueryKeys.all });
		},
	});
}

export function useIgamingScheduledOnDemandPayoutDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingScheduledOnDemandPayoutQueryKeys.all });
		},
	});
}
